module.exports = __webpack_public_path__ + "static/consult-6b34204ecc3c241cb78975a83a160296.svg";